export const withdraws = {
	title: "Retiros, Anticipaciones y Boletas",
	filename: "retiros-anticipaciones-boletas",
	table: {
		datetime: "Fecha de solicitud",
		type: "Tipo",
		status: "Estado",
		username: "Usuario",
		vendor: "Vendor",
		requestedValue: "Valor solicitado",
		liquidAnticipatedValue: "Valor anticipado",
		proRataFee: "Pro rata",
		appliedFee: "Tarifa aplicada",
		proRataFeeTooltip:
			"Tarifa de anticipación proporcional al período del saldo a anticipar",
		totalBruteValue: "Valor bruto total",
		bankAccount: "Cuenta bancaria",
		ticketPayment: "Pago de boleta",
		clientObservation: "Motivo",
		obs: "Observación",
		paymentMethod: "Método de pago",
		attachments: "Anexos",
		confirmWithdrawBtnLabel: "Confirmar solicitud",
	},
	withdrawType: {
		anticipation: "Anticipación",
		withdraw: "Retiro",
		withdrawAndAnticipation: "Retiro y Anticipación",
		bankslip: "Boleta",
	},
	statusType: {
		pending: "Pendiente",
		paid: "Pagado",
		refused: "Negado",
		processing: "Procesando",
		pendingPlaceConfirmation: "Esperando Confirmación",
		cancelled: "Cancelado",
		canceledPlaceConfirmation: "Cancelado",
		processingCancellation: "Procesando cancelación",
		pixProcessing: "Procesando Pix",
		pendingManagerApproval: "Pendiente de aprobación",
		approvedByZigManager: "Aprobado por el gerente de Zig",
		pendingAnticipation: "Pendiente de anticipación",
	},
	paymentType: {
		bankAccount: "Cuenta bancaria",
		bankPaymentSlip: "Pago a proveedores",
	},
	filters: {
		searchAccountPlaceholder: "Buscar por cuenta",
		filterTypePlaceholder: "Filtrar por tipo",
		filterStatusPlaceholder: "Filtrar por estado",
	},
};
